import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Fetch } from './Fetch'
import ReactPlayer from 'react-player'
import {  Box,  IconButton, Stack, Typography } from '@mui/material'
import { CheckCircle, ExpandCircleDown } from '@mui/icons-material'
import { ThumbUp } from '@mui/icons-material'


import RelatedVideo from './RelatedVideo'
import CommentCard from './CommentCard'
import { demoChannelTitle, demoChannelUrl, demoVideoTitle } from '../utils/constant'
const VideoDetail = () => {
  const { id } = useParams();
  const [response, setresponse] = useState([]);
  const [relatedvideo, setrelatedvideo] = useState([]);
  const [comment, setcomment] = useState([]);
  const [click,setclick]=useState(true);
  
  useEffect(() => {
    Fetch(`videos?part=contentDetails&id=${id}`).then((data) => setresponse(data?.items[0]))
      .catch((err) => console.log(err))
    Fetch(`commentThreads?part=snippet&videoId=${id}`).then((data) => setcomment(data?.items))
    Fetch(`search?part=snippet&relatedToVideoId=${id}&type=video`).then((data) => setrelatedvideo(data?.items)).catch((err) => console.log(err))
  }, [id])
  const handleClick=()=>{
    setclick(!click);
  }
  if (!response?.snippet) return 'Loading....';
  return (
    <Box minHeight="95vh" backgroundColor="white">
      <Stack direction={{ xs: 'column', md: 'row' }}>
        <Box flex={1} py={1}>
          <Box width={{ sx: '100%', md: '100%' }}>
            <ReactPlayer url={`http://www.youtube.com/watch?v=${id}`} className='react-player' controls />
            <Typography variant='body1' color="text.primary">
              {response?.snippet?.title || demoVideoTitle}
            </Typography>
            <Stack direction="row" justifyContent="space-between" >
              <Link to={`/channel/${response?.snippet?.channelId}` || demoChannelUrl}>
                <Typography>
                  {response?.snippet?.channelTitle || demoChannelTitle}
                  <CheckCircle sx={{ fontsize: '12px', color: 'black', ml: '5px' }} />
                </Typography>
              </Link>
              <Stack direction="row" gap={2}>
                <Typography>

                  {response?.statistics?.viewCount} views
                </Typography>
                <Typography >
                  <ThumbUp py={2} sx={{ fontSize: '18px' }} mx={2} />
                  {response?.statistics?.likeCount}
                </Typography>
              </Stack>
            </Stack>
          </Box>
          <Box py={4}>
            <Typography backgroundColor="white" sx={{borderBottom:"1px dotted black"}}>{comment?.length}   Comments
            <IconButton onClick={handleClick}>
              <ExpandCircleDown  />
            </IconButton>
            </Typography>
           
            {
              click && comment?.map((e,idx)=>(
                <CommentCard key={idx} data={e?.snippet} />
              ))
            }
          </Box>
        </Box>

        <Box px={2} py={{ md: 1, xs: 5 }} justifyContent="center" alignItems="center" >

          <RelatedVideo data={relatedvideo} />

        </Box>
      </Stack>

    </Box>
  )
}

export default VideoDetail